import { CrudService } from '../base/CrudService';
export class ProjectTemplateService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProjectTemplateService.DEFAULT_SERVICE_PATH,
            basePath: ProjectTemplateService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** GET /api/project-templates?projectTypeId=... */
    async getByType(projectTypeId) {
        const response = await this.getByTypeRaw(projectTypeId);
        return response.data ?? [];
    }
    getByTypeRaw(projectTypeId) {
        return this.http.get(this.buildUrl() + `?projectTypeId=${projectTypeId}`);
    }
    /** POST /api/project-templates/{id}/instantiate */
    async instantiate(templateId, request) {
        const response = await this.instantiateRaw(templateId, request);
        return response.data ?? null;
    }
    instantiateRaw(templateId, request) {
        return this.http.post(this.buildUrl(`${templateId}/instantiate`), request);
    }
}
ProjectTemplateService.DEFAULT_SERVICE_PATH = 'projects';
ProjectTemplateService.BASE_PATH = 'api/project-templates';
//# sourceMappingURL=ProjectTemplateService.js.map